<template>
    <div>
        <div class="row d-flex justify-content-center">
            <div class="col-md-10 mr-auto ml-auto">
                <simple-wizard :finishing="finishing">
                    <template slot="header">
                        <img class="img img-responsive img-center" style="max-width: 150px;"
                             src="/img/ChinuchUKlogo721.png" alt="Chinuch logo">

                        <h3 class="card-title">Build your School Communication System</h3>
<!--                        <hr>-->
<!--                        <h3 style="color: darkred">Due to an increase in demand we're currently unable to start up new-->
<!--                            School Communication Systems. <br>-->
<!--                            Please contact Chinuch UK for more information. </h3>-->

                    </template>
                    <template slot="footer">
                        <p></p>
                    </template>


                                        <wizard-tab :before-change="() => validateStep('step1')">
                                            <template slot="label">
                                                <font-awesome-icon :icon="['fal','building']" size="lg"></font-awesome-icon>
                                                <p>About</p>
                                            </template>
                                            <first-step
                                                ref="step1"
                                                @on-validated="onStepValidated"
                                            ></first-step>
                                        </wizard-tab>

                                        <wizard-tab :before-change="() => validateStep('classes')">
                                            <template slot="label">
                                                <font-awesome-icon :icon="['fal','users-class']" size="lg"></font-awesome-icon>
                                                <p>Classes</p>
                                            </template>
                                            <classes-step
                                                ref="classes"
                                                @on-validated="onStepValidated"
                                            ></classes-step>
                                        </wizard-tab>
                                        <wizard-tab :before-change="() => validateStep('students')">
                                            <template slot="label">
                                                <font-awesome-icon :icon="['fal','user-graduate']" size="lg"></font-awesome-icon>
                                                <p>Students</p>
                                            </template>
                                            <students-step
                                                ref="students"
                                                :amountClasses="wizardModel.classesAmount"
                                                @on-validated="onStepValidated(...arguments, true)"
                                            ></students-step>
                                        </wizard-tab>
                                        <wizard-tab :before-change="() => validateStep('mandates')">
                                            <template slot="label">
                                                <font-awesome-icon :icon="['fal','credit-card']" size="lg"></font-awesome-icon>
                                                <p>Payment</p>
                                            </template>
                                            <mandate-step
                                                ref="mandates"
                                                @on-validated="onStepValidated(...arguments, false)"
                                            ></mandate-step>
                                        </wizard-tab>
                </simple-wizard>
            </div>
        </div>
    </div>
</template>

<script>
    import FirstStep from "./FirstStep";
    import ClassesStep from "./ClassesStep";
    import StudentsStep from "./StudentsStep";
    import MandateStep from "./MandateStep";
    import {SimpleWizard, WizardTab} from "../../../components";

    export default {
        name: "setup",
        data() {
            return {
                wizardModel: {
                    customer_id: null,
                    school_id: null,
                },
                finishing: false,
                finished: false,
            };
        },
        components: {
            FirstStep,
            ClassesStep,
            StudentsStep,
            MandateStep,
            SimpleWizard,
            WizardTab
        },
        computed: {
            enableRTL() {
                return this.$route.query.enableRTL;
            },
            isRTL() {
                return this.$rtl.isRTL;
            },

        },
        methods: {
            validateStep(ref) {
                return this.$refs[ref].validate();
            },
            onStepValidated(validated, model, laststep) {
                this.wizardModel = {...this.wizardModel, ...model};

                if (laststep) {
                    this.wizardComplete();
                }
            },
            wizardComplete() {
                this.finishing = true;
                this.$notify({
                    verticalAlign: 'bottom',
                    horizontalAlign: 'right',
                    message: 'We are setting up your account! Hold tight!',
                    type: "success",
                    title: "Running!",
                    allow_dismiss: false,
                    showProgressbar: false,
                    timeout: 20000
                });

                this.createCustomer()
                    .then(response => {
                        console.log(response.data.data.id);
                        this.wizardModel.customer_id = response.data.data.id;
                        return this.createSchool();
                    })
                    .then(response => {
                        this.wizardModel.school_id = response.data.data.id;
                        return this.createClassrooms();
                    })
                    .then(() => {
                        this.finishing = false;
                        this.finished = true;
                        this.$notify({
                            message: 'Your school has been created!',
                            type: "success",
                            title: "Success!",
                            allow_dismiss: true,
                        });

                        this.$notify({
                            message: 'An email was sent with further instructions',
                            type: "success",
                            title: "Success!",
                            allow_dismiss: true,
                        });

                    });
            },
            createCustomer() {
                return axios({
                    url: this.baseAPIURL + 'hotline/customer',
                    method: 'POST',
                    headers: {
                        'Access-Control-Allow-Origin': '*',
                        'Content-Type': 'application/json',
                    },
                    data: this.wizardModel
                })
            },
            createSchool() {
                return axios({
                    url: this.baseAPIURL + 'hotline/school',
                    method: 'POST',
                    headers: {
                        'Access-Control-Allow-Origin': '*',
                        'Content-Type': 'application/json',
                    },
                    data: this.wizardModel
                })
            },
            createClassrooms() {
                return axios({
                    url: this.baseAPIURL + 'hotline/classroom',
                    method: 'POST',
                    headers: {
                        'Access-Control-Allow-Origin': '*',
                        'Content-Type': 'application/json',
                    },
                    data: this.wizardModel
                })
            },
            setupBilling(customer_id) {
                return axios({
                    url: this.baseAPIURL + 'hotline/customer/' + customer_id + '/billing',
                    method: 'POST',
                    headers: {
                        'Access-Control-Allow-Origin': '*',
                        'Content-Type': 'application/json',
                    }
                })
            },
        },
        mounted() {
            this.i18n = this.$i18n;
            if (this.enableRTL) {
                this.i18n.locale = 'ar';
                this.$rtl.enableRTL();
            }
        },
        beforeDestroy() {
            if (this.$rtl.isRTL) {
                this.i18n.locale = 'en';
                this.$rtl.disableRTL();
            }
        }
    }
</script>

<style scoped>

</style>
